import { render } from "./measureEdit.vue?vue&type=template&id=9a37838c"
import script from "./measureEdit.vue?vue&type=script&lang=js"
export * from "./measureEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__